import { useState, useMemo } from "react";
import { useMedia } from "react-media";
import { useResizeObserver } from "@react-aria/utils";

const GlobalNavHeight = 56; // Default height for the global navigation bar

export function useContentHeight(
  ref: React.RefObject<HTMLElement | undefined>,
  fudge?: { defaultFudge?: number; mobileFudge?: number },
) {
  const [size, setSize] = useState<{ width: number; height: number }>({ width: 0, height: 0 });
  const isMobileGlobalNavVisible = useMedia({ targetWindow: window, query: "(max-width: 640px)" });

  const defaultFudge = fudge?.defaultFudge ?? 0;
  const mobileFudge = fudge?.mobileFudge ?? 0;

  const props = useMemo(
    () => ({
      ref,
      onResize: () => {
        setSize(
          ref.current?.getBoundingClientRect() ?? {
            width: 0,
            height: 0,
          },
        );
      },
    }),
    [ref],
  );
  useResizeObserver(props);

  if (isMobileGlobalNavVisible) return size.height + GlobalNavHeight + mobileFudge;
  return size.height + defaultFudge;
}
